module.exports = __webpack_public_path__ + "static/img/chuzhongyuwen.daa6e989.jpg";